<template>
  <div>
    <div v-if="column === 'createdAt'">
      <RowDate :date="message.createdAt" />
    </div>
    <div v-if="column === 'from'">
      {{ message.from }}
    </div>
    <div v-if="column === 'body'">
      {{ message.body }}
    </div>
    <div v-if="message.item">
      <div v-if="column === 'shipment'">
        <RouterLink :to="shipmentRoute" class="pointer text-light-green">
          {{ message.item.shipmentNumber }}
        </RouterLink>
      </div>
      <div v-if="column === 'carrier'">
        <CarrierData :only-icon="true" :shipment="message.item" />
      </div>
      <div v-if="column === 'recipient'">
        <div>
          {{ toAddressString(message.item.recipientAddress) }}
        </div>

        <div>
          <small class="text-muted">
            {{ addressOwner(message.item.recipientAddress) }}
          </small>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import type { ShipmentEvent } from '@/types/Models/ShipmentEvent'
import type { RouteLocationRaw } from 'vue-router'
import { computed, type ComputedRef, defineComponent, type PropType } from 'vue'
import { useAddressTransformers } from '@/composables/Address/useAddressTransformers'
import { STAFF_SHIPMENTS } from '@/types/router'
import RowDate from '@/views/Components/Elements/Table/RowDate.vue'
import CarrierData from '@/views/Components/Carrier/CarrierData.vue'

export default defineComponent({
  name: 'MessageRow',
  components: {
    CarrierData,
    RowDate,
  },
  props: {
    column: {
      type: String,
      required: true,
    },
    message: {
      type: Object as PropType<ShipmentEvent>,
      required: true,
    },
  },
  setup(props) {
    const shipmentRoute: ComputedRef<RouteLocationRaw> = computed(() => ({
      name: STAFF_SHIPMENTS,
      query: { shipmentNumber: props.message.item?.shipmentNumber },
    }))

    const { toAddressString, addressOwner } = useAddressTransformers()

    return {
      shipmentRoute,
      toAddressString,
      addressOwner,
    }
  },
})
</script>
